import { SubSink } from 'subsink';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ProfileListDetailComponent } from '../profile-list-detail/profile-list-detail.component';
import * as _ from 'lodash';
import { User } from './profile.model';

@Component({
  selector: 'profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['./profile-list.component.scss']
})
export class ProfileListComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;

  searchUsername: any = '';
  searchGroup: any;
  groups: any = [];
  totalItems: number;
  currentPage = 1;
  loading = false;
  list: User[] = [];

  errorMessage: string;

  @ViewChild('detailModal') detailModal: ProfileListDetailComponent;

  private subs = new SubSink();

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.pageChanged();
    this.loadGroups();
  }

  reload() {
    this.pageChanged();
  }

  pageChanged() {
    this.loadData();
  }

  optionChanged() {
    this.search();
  }

  openModal(data, index) {
    this.detailModal.open(this, data);
  }

  search() {
    this.currentPage = 1;
    this.errorMessage = null;
    this.loadData();
  }

  loadData() {
    const data = {
      page: this.currentPage,
      items_per_page: this.itemsPerPage,
      username: this.searchUsername
    };

    if (this.searchGroup != null) {
      data['group'] = this.searchGroup;
    }

    this.loading = true;
    this.subs.add(
      this.apiService.getUsers(data).subscribe(
        (res: any) => {
          this.list = res.results;
          this.totalItems = res.count;
          this.loading = false;
        },
        error => {
          this.loading = false;
        }
      )
    );
  }

  clearSearch() {
    this.searchGroup = null;
    this.searchUsername = '';
  }

  loadGroups() {
    this.groups = [
      {
        label: 'ทั้งหมด',
        value: null
      }
    ];

    this.subs.add(
      this.apiService.getGroups().subscribe(
        groups => {
          _.forEach(groups, group => {
            this.groups.push({
              label: group['name'],
              value: group['id']
            });
          });
        },
        error => {}
      )
    );
  }

  changePermissionAccess(user, accessType) {
    const data = {
      user_id: user.id,
      access_type: accessType,
    };

    this.subs.add(
      this.apiService.setPermissionAccess(data).subscribe(
        (res) => {
          this.loadData();
        },
        (error) => {
          this.loadData();
          this.errorMessage = this.apiService.getErrorMessage(error);
        }
      )
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list/profile-list.component.ts